export default {
  file: {
    zh: '文件',
    en: 'File',
  },
  fileName: {
    zh: '文件名称',
    en: 'File Name',
  },
  fileContent: {
    zh: '文件内容',
    en: 'File Content',
  },
  createFile: {
    zh: '创建文件',
    en: 'Create File',
  },
  uploadFile: {
    zh: '上传文件',
    en: 'Upload File',
  },
  selectFile: {
    zh: '选择文件',
    en: 'Select File',
  },
  unsupportReadOnBrower: {
    zh: '您的浏览器不支持文件读取！',
    en: 'Your browser does not support file reading!',
  },
  readFileError: {
    zh: '读取文件错误',
    en: 'Error reading file!',
  },
  selectUploadType: {
    zh: '方式',
    en: 'Ways',
  },
  uploadByFile: {
    zh: '上传文件',
    en: 'Upload File',
  },
  uploadByContent: {
    zh: '自定义文件',
    en: 'Custom File',
  },
  fileNameRequried: {
    zh: '文件名称不能为空',
    en: 'Please fill in the file name',
  },
  fileContentRequried: {
    zh: '文件内容不能为空',
    en: 'Please fill in the file content',
  },
  fileRequried: {
    zh: '文件不能为空',
    en: 'Please upload a file',
  },
  fileURL: {
    zh: '文件 URL',
    en: 'File URL',
  },
  fileURLRequied: {
    zh: '请选择文件 URL',
    en: 'Please select a file URL',
  },
}
